import { useProviderProps } from "@react-spectrum/provider";
import { useLink } from "@react-aria/link";
import { useHover } from "@react-aria/interactions";
import _react, { useRef } from "react";
import { mergeProps } from "@react-aria/utils";
import { FocusRing } from "@react-aria/focus";
import { classNames, getWrappedElement, useStyleProps } from "@react-spectrum/utils";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/link/vars.css
var $b893bfef2c79e230cc467d335eb860$exports = {};
$b893bfef2c79e230cc467d335eb860$exports = {
  "spectrum-Link": "_spectrum-Link_f1e6e",
  "is-hovered": "_is-hovered_f1e6e",
  "focus-ring": "_focus-ring_f1e6e",
  "is-disabled": "_is-disabled_f1e6e",
  "spectrum-Link--secondary": "_spectrum-Link--secondary_f1e6e",
  "spectrum-Link--overBackground": "_spectrum-Link--overBackground_f1e6e",
  "spectrum-Link--quiet": "_spectrum-Link--quiet_f1e6e"
};
var $b893bfef2c79e230cc467d335eb860$$interop$default = $parcel$interopDefault($b893bfef2c79e230cc467d335eb860$exports);

/**
 * Links allow users to navigate to a different location.
 * They can be presented inline inside a paragraph or as standalone text.
 */
export function Link(props) {
  props = useProviderProps(props);
  let {
    variant = 'primary',
    isQuiet,
    children,
    // @ts-ignore
    href
  } = props;
  let {
    styleProps
  } = useStyleProps(props);
  let {
    hoverProps,
    isHovered
  } = useHover({});

  if (href) {
    console.warn('href is deprecated, please use an anchor element as children');
  }

  let ref = useRef();
  let {
    linkProps
  } = useLink(_babelRuntimeHelpersEsmExtends({}, props, {
    elementType: typeof children === 'string' ? 'span' : 'a'
  }), ref);
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($b893bfef2c79e230cc467d335eb860$$interop$default, 'focus-ring')
  }, _react.cloneElement(getWrappedElement(children), _babelRuntimeHelpersEsmExtends({}, styleProps, mergeProps(linkProps, hoverProps), {
    ref,
    className: classNames($b893bfef2c79e230cc467d335eb860$$interop$default, 'spectrum-Link', {
      'spectrum-Link--quiet': isQuiet,
      ["spectrum-Link--" + variant]: variant,
      'is-hovered': isHovered
    }, styleProps.className)
  })));
}
//# sourceMappingURL=module.js.map
